export default __webpack_public_path__ + "static/media/Ballroll_00061.85568a06.png";